import { Layout } from './layout.model';

export class DefaultLayout implements Layout {
  hasStatusBar: boolean = true;
  hasMenu: boolean = true;
  hasLayout: boolean = true;
  hasLayoutPadding = true;
  autoHideStatusBar = false;
}
